
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { css } from '@emotion/css';
import {
  Content,
  Margin,
  Size,
  Title,
  Padding,
  Text,
  Flex,
  FlexItem,
  Grid,
  GridItem,
  FlexSpacer,
  SelectFilter,
  Shade,
  Tile,
  Direction,
  Speed,
  AnimatedItem,
  AnimationGroup,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
import { Navbar } from './components/Navbar';
export const Item = () => {
  return <Tile noPadding mdxType="Tile">
      <img src={'https://www.brusselstimes.com/wp-content/uploads/2019/07/newtowertallestbrusselsrueloiperspectivebrussels.jpg'} style={{
      width: '100%',
      height: 150,
      objectFit: 'cover'
    }} />
      <Padding size={Size.SMALL} mdxType="Padding">
        <Margin size={{
        bottom: Size.EXTRA_SMALL
      }} mdxType="Margin">
          <Text mdxType="Text">A cool project</Text>
        </Margin>
        <Text size={Size.SMALL} shade={Shade.MEDIUM} mdxType="Text">40% sold</Text>
      </Padding>
    </Tile>;
};

const layoutProps = {
  Item
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Dashboard grid example`}</h1>

<Playground __position={0} __code={`<>
  <Navbar />
  <Content>
    <Padding>
      <AnimationGroup speed={Speed.FAST} direction={Direction.LEFT_RIGHT} staggerChildren>
        <AnimatedItem>
          <Margin size={{ top: Size.DEFAULT, bottom: Size.SMALL }}>
            <Title size={2} noMargin>
              Welcome Amber
            </Title>
          </Margin>
        </AnimatedItem>
        <AnimatedItem>
          <Text>
            Start by creating a projet
          </Text>
        </AnimatedItem>
      </AnimationGroup>
      <Margin size={{ top: Size.EXTRA_LARGE, bottom: Size.LARGE }}>
        <Flex animationDelay={300} animated animationDirection={Direction.TOP_DOWN} animationSpeed={Speed.FAST}>
          <FlexItem>
            <Title size={4} noMargin>
              Projects
            </Title>
          </FlexItem>
          <FlexSpacer flex size={Size.SMALL} />
          <FlexItem>
            <SelectFilter
              label="Filter"
              onChange={() => {}}
              onClear={() => {}}
              options={[]}
            />
          </FlexItem>
          <FlexSpacer size={Size.SMALL} />
          <FlexItem>
            <SelectFilter
              label="Filter"
              onChange={() => {}}
              onClear={() => {}}
              options={[]}
            />
          </FlexItem>
          <FlexSpacer size={Size.SMALL} />
          <FlexItem>
            <SelectFilter
              label="Filter"
              onChange={() => {}}
              onClear={() => {}}
              options={[]}
            />
          </FlexItem>
        </Flex>
      </Margin>
      <Grid animated animationDelay={600} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} columns={4}>
        {[...Array(8).keys()].map((i) =>
          <GridItem key={i}>
            <Item />
          </GridItem>
        )}
      </Grid>
    </Padding>
  </Content>
</>`} mode="jsx" mdxType="Playground">
  <>
    <Navbar mdxType="Navbar" />
    <Content mdxType="Content">
      <Padding mdxType="Padding">
        <AnimationGroup speed={Speed.FAST} direction={Direction.LEFT_RIGHT} staggerChildren mdxType="AnimationGroup">
          <AnimatedItem mdxType="AnimatedItem">
            <Margin size={{
                  top: Size.DEFAULT,
                  bottom: Size.SMALL
                }} mdxType="Margin">
              <Title size={2} noMargin mdxType="Title">
                Welcome Amber
              </Title>
            </Margin>
          </AnimatedItem>
          <AnimatedItem mdxType="AnimatedItem">
            <Text mdxType="Text">
              Start by creating a projet
            </Text>
          </AnimatedItem>
        </AnimationGroup>
        <Margin size={{
              top: Size.EXTRA_LARGE,
              bottom: Size.LARGE
            }} mdxType="Margin">
          <Flex animationDelay={300} animated animationDirection={Direction.TOP_DOWN} animationSpeed={Speed.FAST} mdxType="Flex">
            <FlexItem mdxType="FlexItem">
              <Title size={4} noMargin mdxType="Title">
                Projects
              </Title>
            </FlexItem>
            <FlexSpacer flex size={Size.SMALL} mdxType="FlexSpacer" />
            <FlexItem mdxType="FlexItem">
              <SelectFilter label="Filter" onChange={() => {}} onClear={() => {}} options={[]} mdxType="SelectFilter" />
            </FlexItem>
            <FlexSpacer size={Size.SMALL} mdxType="FlexSpacer" />
            <FlexItem mdxType="FlexItem">
              <SelectFilter label="Filter" onChange={() => {}} onClear={() => {}} options={[]} mdxType="SelectFilter" />
            </FlexItem>
            <FlexSpacer size={Size.SMALL} mdxType="FlexSpacer" />
            <FlexItem mdxType="FlexItem">
              <SelectFilter label="Filter" onChange={() => {}} onClear={() => {}} options={[]} mdxType="SelectFilter" />
            </FlexItem>
          </Flex>
        </Margin>
        <Grid animated animationDelay={600} hGutters={Size.DEFAULT} vGutters={Size.DEFAULT} columns={4} mdxType="Grid">
          {[...Array(8).keys()].map(i => <GridItem key={i} mdxType="GridItem">
              <Item mdxType="Item" />
            </GridItem>)}
        </Grid>
      </Padding>
    </Content>
  </>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;